module.exports = __webpack_public_path__ + "img/cloud-check-fill.2a4b9858.svg";